import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { Store } from "@ngxs/store";

export const passwordExpiredGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  const userState = store.selectSnapshot<any>((state) => state.UserState);

  if (userState?.isPasswordExpired && userState?.user?.userId) {
    return true;
  }

  if (
    userState?.isUpdatePassword &&
    userState?.user?.userId &&
    userState?.tempUserId &&
    userState?.tempPass
  ) {
    return router.createUrlTree(["/first-time-login"]);
  }

  return router.createUrlTree(["/login"]);
};
